module.exports = __webpack_public_path__ + "media/images/pc/stores/hamamatsu/hamamatsu_concept_03-c96e6464f73ee7a1ffcd41e3d6deaeff.jpg";